import React from "react";
import { Share2, MessageSquare, Download } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { toast } from "sonner";

const dataUrlToFile = async (url, name) => new File([await (await fetch(url)).blob()], name, { type: "image/jpeg" });

export function ReceiptShareDialog({ receipt, onClose }) {
  if (!receipt) return null;
  const name = `PTG-Receipt-${receipt.no}.jpg`;
  const text = `PTG Receipt ${receipt.no}: Rs ${receipt.amount} ${receipt.mode} for ${receipt.student} (${receipt.std || ""}) ${receipt.bill || ""} on ${receipt.date}. Final receipt after office approval.`;
  const share = async () => {
    try {
      const file = await dataUrlToFile(receipt.image, name);
      if (navigator.canShare && navigator.canShare({ files: [file] })) { await navigator.share({ files: [file], text }); return; }
      toast.error("Sharing images isn't supported on this browser — use Download, then send on WhatsApp.");
    } catch (e) { if (e?.name !== "AbortError") toast.error("Could not open share"); }
  };
  const smsHref = `sms:${receipt.mobile ? `+91${String(receipt.mobile).replace(/\D/g, "").slice(-10)}` : ""}?&body=${encodeURIComponent(text)}`;
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-lg" data-testid="receipt-share-dialog">
        <DialogHeader>
          <DialogTitle>Receipt No. {receipt.no} created</DialogTitle>
          <DialogDescription>Send it to the parent and to the office now.</DialogDescription>
        </DialogHeader>
        <img src={receipt.image} alt={`Receipt ${receipt.no}`} className="w-full rounded-lg border" data-testid="receipt-share-image" />
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-2">
          <Button onClick={share} className="bg-green-600 hover:bg-green-700" data-testid="receipt-share-whatsapp"><Share2 className="h-4 w-4 mr-1" /> Share (WhatsApp)</Button>
          <a href={smsHref} onClick={() => { if (!receipt.mobile) toast.info("No parent mobile on file — type the number in your SMS app"); }} data-testid="receipt-share-sms"><Button variant="outline" className="w-full"><MessageSquare className="h-4 w-4 mr-1" /> Send SMS</Button></a>
          <a href={receipt.image} download={name} data-testid="receipt-share-download"><Button variant="outline" className="w-full"><Download className="h-4 w-4 mr-1" /> Download</Button></a>
        </div>
        <p className="text-[11px] text-slate-500">In WhatsApp, select the parent and the PTG office number together, then press Send.</p>
      </DialogContent>
    </Dialog>
  );
}
